import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
  Image,
} from "@react-pdf/renderer";
import logo from "../../../Pages/Images/SMJ_Logo.png";
import instalogo from "../../../Pages/Images/insta_logo.png";
import { toWords } from "number-to-words";

// Promo page assets
import promoLogo from "../../../Pages/Images/SMJ_Logo.png";
import amazonLogo from "../../../Pages/Images/amazon.png";
import myntraLogo from "../../../Pages/Images/myntra.png";
import flipkartLogo from "../../../Pages/Images/flipkart.png";
import tickIcon from "../../../Pages/Images/tickicon.jpeg";
import diamondIcon from "../../../Pages/Images/diamond.png";
import sparkaleIcon from "../../../Pages/Images/Sparkle.png";
import giftIcon from "../../../Pages/Images/Gift.png";
import ringIcon from "../../../Pages/Images/Ring.jpeg";
import moneyIcon from "../../../Pages/Images/Money.jpg";
import voucherIcon from "../../../Pages/Images/Voucher.png";
import qrScanner from "../../../Pages/Images/QR1.png";

// Register fonts
Font.register({
  family: "Helvetica",
});

Font.register({
  family: "Helvetica-Bold",
  src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf",
});

// Styles
const styles = StyleSheet.create({
  page: {
    padding: 8,
    fontSize: 8,
    fontFamily: "Helvetica",
  },
  topRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 3,
  },
  smallBold: {
    fontSize: 8,
    fontFamily: "Helvetica-Bold",
  },
  logo: {
    width: 40,
    height: 40,
    marginHorizontal: 4,
  },
  title: {
    fontSize: 14,
    fontFamily: "Helvetica-Bold",
    textAlign: "center",
  },
  tagline: {
    fontSize: 9,
    fontStyle: "italic",
    textAlign: "center",
    marginTop: 4,
  },
  address: {
    fontSize: 8,
    marginTop: 5,
    textAlign: "center",
  },
  sup: {
    fontSize: 5,
    textBaseline: "alphabetic",
  },
  sectionRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 8,
    paddingHorizontal: 2,
  },
  sectionLeft: {
    width: "60%",
  },
  sectionRight: {
    width: "40%",
    textAlign: "right",
  },
  label: {
    fontSize: 9,
    fontFamily: "Helvetica-Bold",
  },
  value: {
    fontSize: 8,
    marginBottom: 1,
  },

  // Table styles
  table: {
    display: "table",
    width: "100%",
    borderWidth: 0.5,
    borderColor: "#000",
    marginTop: 6,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableColHeader: {
    flex: 1,
    backgroundColor: "#000",
    padding: 2,
    borderWidth: 0.5,
    borderColor: "#000",
  },
  tableCol: {
    flex: 1,
    borderWidth: 0.5,
    borderColor: "#000",
    padding: 2,
  },
  tableHeaderText: {
    fontSize: 8,
    color: "#fff",
    fontFamily: "Helvetica-Bold",
    textAlign: "center",
  },
  tableCell: {
    fontSize: 8,
    textAlign: "center",
  },

  // Summary section
  summaryRow: {
    flexDirection: "row",
    marginTop: 6,
  },
  summaryLeft: {
    flex: 1,
    borderWidth: 0.5,
    borderColor: "#000",
  },
  summaryRight: {
    flex: 1,
    borderWidth: 0.5,
    borderColor: "#000",
  },
  summaryHeader: {
    backgroundColor: "#000",
    flexDirection: "row",
  },
  summaryHeaderText: {
    flex: 1,
    color: "#fff",
    fontSize: 7,
    fontFamily: "Helvetica-Bold",
    textAlign: "center",
    padding: 2,
  },
  summaryRowItem: {
    flexDirection: "row",
    borderTopWidth: 0.5,
    borderColor: "#000",
  },
  summaryCell: {
    flex: 1,
    fontSize: 7,
    textAlign: "center",
    padding: 2,
  },

  // Amount + total section
  amountTotalRow: {
    flexDirection: "row",
    marginTop: 8,
    paddingHorizontal: 2,
  },
  amountSection: {
    flex: 1,
    paddingRight: 6,
  },
  amountInWords: {
    fontSize: 10,
    fontFamily: "Helvetica-Bold",
    marginBottom: 2,
  },
  amountInWordsText: {
    fontSize: 9,
    marginBottom: 2,
  },
  totalSection: {
    flex: 1,
    paddingLeft: 6,
  },
  totalRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 3,
  },
  totalLabel: {
    fontSize: 10,
    fontFamily: "Helvetica-Bold",
    width: "60%",
  },
  totalValue: {
    fontSize: 10,
    width: "40%",
    textAlign: "right",
  },

  noteSection: {
    marginTop: 6,
    marginBottom: 8,
  },
  noteHeading: {
    fontSize: 9,
    fontFamily: "Helvetica-Bold",
    marginBottom: 3,
  },
  noteText: {
    fontSize: 8,
    marginBottom: 2,
  },

  footer: {
    marginTop: 12,
    alignItems: "center",
  },
  thankYou: {
    fontSize: 11,
    fontFamily: "Helvetica-Bold",
    marginBottom: 4,
  },
  copyright: {
    fontSize: 8,
    marginTop: 6,
  },
  horizontalLine: {
    borderBottomWidth: 0.5,
    borderBottomColor: "#000",
    marginVertical: 4,
    width: "100%",
  },

  // Column width styles
  colSNo: {
    width: "8%",
    borderWidth: 0.5,
    borderColor: "#000",
    padding: 2,
    justifyContent: "center",
  },
  colMetal: {
    width: "19%",
    borderWidth: 0.5,
    borderColor: "#000",
    padding: 2,
    justifyContent: "center",
  },
  colParticulars: {
    width: "38%",
    borderWidth: 0.5,
    borderColor: "#000",
    padding: 2,
    justifyContent: "center",
  },
  colNtWt: {
    width: "12%",
    borderWidth: 0.5,
    borderColor: "#000",
    padding: 2,
    justifyContent: "center",
  },
  colHSN: {
    width: "15%",
    borderWidth: 0.5,
    borderColor: "#000",
    padding: 2,
    justifyContent: "center",
  },
  colAmount: {
    width: "18%",
    borderWidth: 0.5,
    borderColor: "#000",
    padding: 2,
    justifyContent: "center",
  },
});

// ✅ Styles for static promo page
const promoStyles = StyleSheet.create({
  page: { padding: 8, fontSize: 8, fontFamily: "Helvetica" },
  topRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  smallBold: { fontSize: 8, fontFamily: "Helvetica-Bold" },
  logo: { width: 30, height: 30, marginHorizontal: 4 },
  title: { fontSize: 14, fontFamily: "Helvetica-Bold", textAlign: "center" },
  tagline: {
    fontSize: 9,
    fontStyle: "italic",
    textAlign: "center",
    marginTop: 4,
  },
  address: { fontSize: 8, marginTop: 5, textAlign: "center" },
  sup: { fontSize: 5, textBaseline: "alphabetic" },

  // Promo specific styles
  promoContainer: { marginTop: 8 },
  mainTitle: {
    fontSize: 12,
    fontFamily: "Helvetica-Bold",
    textAlign: "center",
    marginRight: 6,
  },
  subtitle: {
    fontSize: 9,
    textAlign: "center",
    marginBottom: 10,
    lineHeight: 1.3,
  },

  // Investment sections
  investmentSection: { marginBottom: 10 },
  investmentTitle: {
    fontSize: 12,
    fontFamily: "Helvetica-Bold",
    marginBottom: 4,
  },
  investmentSubtitle: { fontSize: 9, fontStyle: "italic", marginBottom: 6 },
  featureItem: {
    flexDirection: "row",
    alignItems: "flex-start",
    marginBottom: 3,
  },
  checkbox: {
    width: 8,
    height: 8,
    borderWidth: 0.5,
    borderColor: "#000",
    marginRight: 4,
    marginTop: 1,
  },
  checkedCheckbox: {
    width: 8,
    height: 8,
    borderWidth: 0.5,
    borderColor: "#000",
    marginRight: 4,
    marginTop: 1,
    backgroundColor: "#000",
  },
  featureText: { fontSize: 9, lineHeight: 1.2, flex: 1 },

  // Footer
  footer: { marginTop: 8, alignItems: "center" },
  thankYou: { fontSize: 11, fontFamily: "Helvetica-Bold", marginBottom: 4 },
  copyright: { fontSize: 8, marginTop: 6 },
  separator: { borderTopWidth: 0.5, borderTopColor: "#000", marginVertical: 6 },
  instaRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 4,
  },
  instaLogo: { width: 10, height: 10, marginRight: 3 },
  instaText: { fontSize: 8 },
});

const InvoiceDocument = ({
  formData,
  repairDetails,
  cash_amount,
  discountAmt,
  festivalDiscountAmt,
  card_amt,
  chq_amt,
  online_amt,
  totalAmount,
  taxableAmount,
  taxAmount,
  oldItemsAmount,
  schemeAmount,
  salesNetAmount,
  netAmount,
  netPayableAmount,
  product,
  oldItems = [],
  totalMakingCharges = 0,
  totalStonePrice = 0,
}) => {
  // Calculate total values from repairDetails
  const totalValues = repairDetails?.reduce(
    (totals, item) => {
      return {
        qty: totals.qty + Number(item.qty || 0),
        grossWeight: totals.grossWeight + Number(item.gross_weight || 0),
        stoneWeight: totals.stoneWeight + Number(item.stone_weight || 0),
        netWeight: totals.netWeight + Number(item.total_weight_av || 0),
        rate: totals.rate + Number(item.rate || 0),
        makingCharges: totals.makingCharges + Number(item.making_charges || 0),
        stonePrice: totals.stonePrice + Number(item.stone_price || 0),
        rateAmount: totals.rateAmount + Number(item.rate_amt || 0),
      };
    },
    {
      qty: 0,
      grossWeight: 0,
      stoneWeight: 0,
      netWeight: 0,
      rate: 0,
      makingCharges: 0,
      stonePrice: 0,
      rateAmount: 0,
    },
  ) || {
    qty: 0,
    grossWeight: 0,
    stoneWeight: 0,
    netWeight: 0,
    rate: 0,
    makingCharges: 0,
    stonePrice: 0,
    rateAmount: 0,
  };

  // Convert amount to words
  const amountInWords = toWords(netPayableAmount || 0).replace(
    /(^\w|\s\w)/g,
    (m) => m.toUpperCase(),
  );

  const formatRate = (val) => {
    const num = parseFloat(val) || 0;
    return num % 1 === 0 ? num.toString() : num.toFixed(2).replace(/\.?0+$/, "");
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Get current time
  const currentTime = new Date().toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });

  // Calculate balance amount
  const balanceAmount = Math.max(
    0,
    Math.round(
      (Number(netPayableAmount) || 0) -
      ((Number(cash_amount) || 0) +
        (Number(chq_amt) || 0) +
        (Number(card_amt) || 0) +
        (Number(online_amt) || 0)),
    ),
  ).toFixed(2);

  return (
    <Document>
      <Page size={[300, 500]} style={styles.page}>
        {/* Top Row: GSTIN | Logo | Contact */}
        <View style={styles.topRow}>
          <Text style={styles.smallBold}>GSTIN: 29ADOPG5916E1ZE</Text>
          <Image src={logo} style={styles.logo} />
          <View>
            <Text style={styles.smallBold}>Contact: 916 916 9680</Text>
            <Text style={[styles.smallBold, { marginLeft: 33 }]}>
              080 26719107
            </Text>
          </View>
        </View>

        {/* Title + tagline + address */}
        <Text style={styles.title}>Sri Mahaganapathi Jewellers</Text>
        <Text style={[styles.tagline, { marginLeft: 50 }]}>
          Our Craft For Your Precious Stories
        </Text>
        <Text style={styles.address}>
          No 606, 14<Text style={styles.sup}>th</Text> Main Road, Siddanna
          Layout, BSK 2<Text style={styles.sup}>nd</Text> Stage
        </Text>

        {/* Customer Details + Invoice Info */}
        <View style={styles.sectionRow}>
          <View style={styles.sectionLeft}>
            <Text style={styles.label}>Customer Details:</Text>
            <Text style={styles.value}>
              Name: {formData?.account_name || "N/A"}
            </Text>
            <Text style={styles.value}>
              Mobile: {formData?.mobile || "N/A"}
            </Text>
            <Text style={styles.value}>
              GSTIN: {formData?.pan_card || "N/A"}
            </Text>
          </View>
          <View style={styles.sectionRight}>
            <Text style={styles.value}>
              Invoice No: {formData?.invoice_number || "N/A"}
            </Text>
            <Text style={styles.value}>Date: {formatDate(formData?.date)}</Text>
            <Text style={styles.value}>Time: {currentTime}</Text>
          </View>
        </View>

        {/* Items Table */}
        <View style={styles.table}>
          {/* Header */}
          <View style={styles.tableRow}>
            <View style={[styles.colSNo, { backgroundColor: "#000" }]}>
              <Text style={styles.tableHeaderText}>S.No</Text>
            </View>
            <View style={[styles.colMetal, { backgroundColor: "#000" }]}>
              <Text style={styles.tableHeaderText}>Metal</Text>
            </View>
            <View style={[styles.colParticulars, { backgroundColor: "#000" }]}>
              <Text style={styles.tableHeaderText}>Particulars / Gr. Wt</Text>
            </View>
            <View style={[styles.colNtWt, { backgroundColor: "#000" }]}>
              <Text style={styles.tableHeaderText}>WAW</Text>
            </View>
            <View style={[styles.colHSN, { backgroundColor: "#000" }]}>
              <Text style={styles.tableHeaderText}>HSN</Text>
            </View>
            <View style={[styles.colAmount, { backgroundColor: "#000" }]}>
              <Text style={styles.tableHeaderText}>Amount</Text>
            </View>
          </View>

          {/* Table Rows */}
          {repairDetails?.map((item, index) => {
            const matchedProduct = product.find(
              (p) => p.product_name === item.category,
            );
            const mcValue = parseFloat(item.mc_per_gram || 0);
            const stonePrice = parseFloat(item.stone_price || 0);
            const ratePerGram =
              parseFloat(item.rate) ||
              (parseFloat(item.rate_amt) || 0) / (parseFloat(item.total_weight_av) || 1);

            return (
              <React.Fragment key={index}>
                {/* Main Item Row */}
                <View style={[styles.tableRow, { borderBottomWidth: 0 }]}>
                  <View style={[styles.colSNo, { borderBottomWidth: 0 }]}>
                    <Text style={styles.tableCell}>{index + 1}</Text>
                  </View>
                  <View style={[styles.colMetal, { borderBottomWidth: 0 }]}>
                    <Text style={styles.tableCell}>
                      {item.metal_type || "N/A"}
                    </Text>
                  </View>
                  <View style={[styles.colParticulars, { borderBottomWidth: 0 }]}>
                    <Text style={styles.tableCell}>
                      {item.product_name || "N/A"}{" "}
                      {item.gross_weight ? `${item.gross_weight}g` : ""}
                    </Text>
                  </View>
                  <View style={[styles.colNtWt, { borderBottomWidth: 0 }]}>
                    <Text style={styles.tableCell}>
                      {item.total_weight_av || "0.000"}
                    </Text>
                  </View>
                  <View style={[styles.colHSN, { borderBottomWidth: 0 }]}>
                    <Text style={styles.tableCell}>{matchedProduct?.hsn_code || "7113"}</Text>
                  </View>
                  <View style={[styles.colAmount, { borderBottomWidth: 0 }]}>
                    <Text style={styles.tableCell}>
                      {(
                        parseFloat(item.rate_amt || 0) +
                        parseFloat(item.stone_price || 0) +
                        parseFloat(item.making_charges || 0)
                      ).toFixed(2)}
                    </Text>
                  </View>
                </View>

                {/* Sub-row for Metal Rate, MC, and Stone Price */}
                {/* Sub-row for Metal Rate, MC, and Stone Price */}
                {(ratePerGram > 0 || mcValue > 0 || stonePrice > 0) && (
                  <View style={[styles.tableRow, { backgroundColor: "#f9f9f9", borderTopWidth: 0 }]}>

                    {/* S.No Column */}
                    <View style={[styles.colSNo, { justifyContent: "center", borderTopWidth: 0, borderBottomWidth: 0.5 }]}>
                      <Text style={styles.tableCell}></Text>
                    </View>

                    {/* Metal Column - Displays Rate */}
                    <View style={[styles.colMetal, { justifyContent: "center", borderTopWidth: 0, borderBottomWidth: 0.5 }]}>
                      {ratePerGram > 0 ? (
                        <Text style={styles.tableCell}>
                          Rate: {formatRate(ratePerGram)}
                        </Text>
                      ) : (
                        <Text style={styles.tableCell}></Text>
                      )}
                    </View>

                    {/* Particulars Column - Displays MC & Stone Price */}
                    <View style={[styles.colParticulars, { justifyContent: "center", borderTopWidth: 0, borderBottomWidth: 0.5 }]}>
                      <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                        <Text style={[styles.tableCell, { textAlign: "left" }]}>
                          MC: {mcValue.toFixed(2)}
                        </Text>
                        <Text style={[styles.tableCell, { textAlign: "right", marginLeft: 10 }]}>
                          Stn Rs. {stonePrice.toFixed(2)}
                        </Text>
                      </View>
                    </View>

                    {/* WAW Column */}
                    <View style={[styles.colNtWt, { justifyContent: "center", borderTopWidth: 0, borderBottomWidth: 0.5 }]}>
                      <Text style={styles.tableCell}></Text>
                    </View>

                    {/* HSN Column */}
                    <View style={[styles.colHSN, { justifyContent: "center", borderTopWidth: 0, borderBottomWidth: 0.5 }]}>
                      <Text style={styles.tableCell}></Text>
                    </View>

                    {/* Amount Column */}
                    <View style={[styles.colAmount, { justifyContent: "center", borderTopWidth: 0, borderBottomWidth: 0.5 }]}>
                      <Text style={styles.tableCell}></Text>
                    </View>
                  </View>
                )}
              </React.Fragment>
            );
          })}
        </View>

        {/* Summary Section */}
        <View style={styles.summaryRow}>
          {/* Left Part */}
          {/* Old Items Section with Individual Items */}
          {oldItems && oldItems.length > 0 && (
            <View style={styles.summaryLeft}>
              <View style={styles.summaryHeader}>
                <Text style={styles.summaryHeaderText}>Old Items Details</Text>
                <Text style={styles.summaryHeaderText}>Amount</Text>
              </View>
              {oldItems.map((item, idx) => (
                <View style={styles.summaryRowItem} key={idx}>
                  <Text style={styles.summaryCell}>
                    {item.product || 'N/A'}
                  </Text>
                  <Text style={styles.summaryCell}>
                    {parseFloat(item.total_amount || 0).toFixed(2)}
                  </Text>
                </View>
              ))}
              <View style={[styles.summaryRowItem, { backgroundColor: '#f0f0f0' }]}>
                <Text style={[styles.summaryCell, { fontFamily: 'Helvetica-Bold' }]}>
                  Old Total Amount
                </Text>
                <Text style={[styles.summaryCell, { fontFamily: 'Helvetica-Bold' }]}>
                  {oldItemsAmount?.toFixed(2) || "0.00"}
                </Text>
              </View>
            </View>
          )}

          {/* Right Part */}
          <View style={styles.summaryRight}>
            <View style={styles.summaryHeader}>
              <Text style={styles.summaryHeaderText}>GST Val</Text>
              <Text style={styles.summaryHeaderText}>
                {taxableAmount?.toFixed(2) || "0.00"}
              </Text>
            </View>
            <View style={styles.summaryRowItem}>
              <Text style={styles.summaryCell}>CGST 1.5%</Text>
              <Text style={styles.summaryCell}>
                {((taxAmount || 0) / 2).toFixed(2)}
              </Text>
            </View>
            <View style={styles.summaryRowItem}>
              <Text style={styles.summaryCell}>SGST 1.5%</Text>
              <Text style={styles.summaryCell}>
                {((taxAmount || 0) / 2).toFixed(2)}
              </Text>
            </View>
            <View style={styles.summaryRowItem}>
              <Text style={styles.summaryCell}>Total</Text>
              <Text style={styles.summaryCell}>
                {netAmount?.toFixed(2) || "0.00"}
              </Text>
            </View>
          </View>
        </View>

        {/* Amount in Words + Total Section (side by side) */}
        <View style={styles.amountTotalRow}>
          {/* Amount in Words Left */}
          <View style={styles.amountSection}>
            <Text style={styles.amountInWords}>Amount In Words:</Text>
            <Text style={styles.amountInWordsText}>
              {amountInWords} Rupees Only
            </Text>
          </View>

          {/* Total Section Right */}
          <View style={styles.totalSection}>
            <View style={styles.totalRow}>
              <Text style={styles.totalLabel}>Total Amount:</Text>
              <Text style={styles.totalValue}>
                {netAmount?.toFixed(2) || "0.00"}
              </Text>
            </View>

            <View style={styles.totalRow}>
              <Text style={styles.totalLabel}>Discount:</Text>
              <Text style={styles.totalValue}>
                {" "}
                (-) {(Number(discountAmt) || 0).toFixed(2)}
              </Text>
            </View>
            <View style={styles.totalRow}>
              <Text style={styles.totalLabel}>Amt Payable:</Text>
              <Text style={styles.totalValue}>
                {(Math.round(Number(netPayableAmount)) || 0).toFixed(2)}
              </Text>
            </View>

            <View style={styles.totalRow}>
              <Text style={styles.totalLabel}>Balance:</Text>
              <Text style={styles.totalValue}>{balanceAmount}</Text>
            </View>
          </View>
        </View>

        {/* Payment Methods */}
        <View style={[styles.sectionRow, { marginTop: 4 }]}>
          <View style={styles.sectionLeft}>
            <Text style={styles.label}>Payment Received:</Text>
            <Text style={styles.value}>
              Cash: {(Number(cash_amount) || 0).toFixed(2)}
            </Text>
            <Text style={styles.value}>
              Card: {(Number(card_amt) || 0).toFixed(2)}
            </Text>
          </View>
          <View style={styles.sectionRight}>
            <Text style={styles.value}></Text>
            <Text style={styles.value}>
              Cheque: {(Number(chq_amt) || 0).toFixed(2)}
            </Text>
            <Text style={styles.value}>
              Online: {(Number(online_amt) || 0).toFixed(2)}
            </Text>
          </View>
        </View>

        {/* Note Section */}
        <View style={styles.noteSection}>
          <Text style={styles.noteHeading}>Note:</Text>
          <Text style={styles.noteText}>
            1. Goods once sold will not be taken back or exchanged.
          </Text>
          <Text style={styles.noteText}>
            2. The above-mentioned goods are delivered to you with complete
            approval and are accepted by you after full checking.
          </Text>
          <Text style={styles.noteText}>
            3. We are responsible only for the purity of 916 Gold Ornaments, not
            for any other damages.
          </Text>
        </View>

        {/* Footer */}
        <View style={styles.footer}>
          <Text style={styles.thankYou}>Thank You | Visit Again</Text>

          {/* Left & Right Side */}
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              width: "100%",
              alignItems: "center",
            }}
          >
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <Image
                src={instalogo}
                style={{ width: 12, height: 12, marginRight: 1, marginTop: 5 }}
              />
              <Text style={styles.copyright}>jewellers_srimahaganapathi</Text>
            </View>
            <Text style={styles.copyright}>SMJ Authorized Sign</Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default InvoiceDocument;